import clsx from 'clsx'

import { Text } from 'src/components/Text/Text'
import { useLocale } from 'src/contexts/LocaleContext'
import { removeBioOrganic } from 'src/functions/product/removeBioOrganic'
import { pathHelper } from 'src/functions/util/pathHelper'

import styles from './CartLineItemInfo.module.scss'

import type { Merchandise } from 'src/data/graphql-generated'

interface CartLineItemInfoProps {
  item: {
    merchandise: Merchandise
  }
  inMinicart?: boolean
}

export const CartLineItemInfo = ({
  item: {
    merchandise: {
      title: variantTitle,
      sku,
      product: {
        title: productTitle,
        handle,
        productType,
        variants: { nodes: variants },
      },
    },
  },
  inMinicart = false,
}: CartLineItemInfoProps) => {
  const { language } = useLocale()
  const productTitleWithoutBio = removeBioOrganic(productTitle)

  return (
    <Text className={clsx(styles.productInfoContainer, inMinicart && styles.inMinicart)}>
      <a
        className={styles.productTitle}
        href={pathHelper(productType, language, handle, sku, true, true)}
        aria-label={`${productTitleWithoutBio} ${variantTitle}`}
      >
        <strong>{productTitleWithoutBio}</strong>
      </a>
      {variants.length > 1 && (
        <div className={styles.variantTitle} data-testid="variant-title">
          {variantTitle}
        </div>
      )}
    </Text>
  )
}
